import * as api from "Api";
import * as actions from "Actions";

export const fetchTaskTypeStatistics = typeId => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    const { selected } = getState().statistics.categories.years;
    return dispatch(
      actions.fetchTaskTypeStatistics(
        api.getTaskTypeStatistics({
          id: typeId,
          organization: id,
          years: selected
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/statistics.js